const state = {
    issearching:false,
    searchvalue:'',
};

const getters = {
    isSearching: state => state.issearching,
    getSearchvalue: state => state.searchvalue,
};

const actions = {
    clearSearching: (store) => store.commit('SEARCHING_CLEAR'),
    setSearchvalue: (store, payload) => store.commit('SEARCHVALUE_SET',payload),
};

const mutations = {
    SEARCHING_CLEAR: (state) => state.issearching = false,
    SEARCHVALUE_SET: (state, payload) => {
        state.issearching = true;
        state.searchvalue = payload;
    },
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
